<template>
  <div style="opsition:absolute;z-index:9999;">
    <!-- 线索备注 -->
    <Modal
      v-model="caseNotesCtrl"
      title="便签"
      :width="450"
      :footer-hide="true"
      @on-cancel="cancel"
    >
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="关注程度" prop="attention">
          <RadioGroup v-model="formValidate.attention">
            <Radio label="N">一般</Radio>
            <Radio label="Y">重要</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="note">
          <Input v-model.trim="formValidate.note" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写备注信息(不超过512个字符)" />
        </FormItem>
      </Form>
      <!-- 有数据并大于一定数量就滚动加载 -->
      <Row v-if="noteList.length>4">
        <Scroll :on-reach-bottom="handleReachBottom">
          <Timeline style="margin-left:10px;">
            <TimelineItem v-for="(item, index) in noteList" :key="index">
              <Icon slot="dot" type="ios-radio-button-on" :size="18" :color="styles.globalMainColor" />
              <Row class="line-content">
                <Row class="line-right">
                  <span v-if="item.attention =='Y'" class="line-name import-attention fs-16">{{ item.memo }}</span>
                  <span v-if="item.attention =='N'" class="line-name fs-16">{{ item.memo }}</span>
                  <a v-if="item.operatePermission" href="javascript:void(0);" style="padding-left:10px" @click="deleteMemo(item.id)">删除</a>
                  <div class="line-time">
                    <span>添加人：{{ item.creatorName }}</span>
                    <span>添加时间：{{ item.createTime }}</span>
                  </div>
                </Row>
              </Row>
            </TimelineItem>
          </Timeline>
        </Scroll>
      </Row>
      <Row v-else>
        <Timeline style="margin-left:10px;">
          <TimelineItem v-for="(item, index) in noteList" :key="index">
            <Icon slot="dot" type="ios-radio-button-on" :size="18" :color="styles.globalMainColor" />
            <Row class="line-content">
              <Row class="line-right">
                <span v-if="item.attention =='Y'" class="line-name import-attention fs-16">{{ item.memo }}</span>
                <span v-if="item.attention =='N'" class="line-name fs-16">{{ item.memo }}</span>
                <a v-if="item.operatePermission" href="javascript:void(0);" style="padding-left:10px" @click="deleteMemo(item.id)">删除</a>
                <div class="line-time">
                  <span>添加人：{{ item.creatorName }}</span>
                  <span>添加时间：{{ item.createTime }}</span>
                </div>
              </Row>
            </Row>
          </TimelineItem>
        </Timeline>
      </Row>
      <Row style="text-align:center;margin-top:10px;">
        <Button type="primary" :disabled="isSubmit" @click="caseNoteSubmit('formValidate')">确认</Button>
        <Button style="margin-left: 8px" @click="cancel">取消</Button>
      </Row>
    </Modal>

    <!-- 删除备注确认-->
    <Modal
      v-model="deleteMomeCtrl"
      title="删除确认"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">请问是否删除此记录？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button type="primary" :disabled="isSubmit" @click="isDeleteFn">确认</Button>
        <Button style="margin-left: 8px" @click="deleteMomeCtrl=false;">取消</Button>
      </Row>
    </Modal>
  </div>
</template>

<script>
import styles from '@/assets/globalStyle.scss'
export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      styles: styles,
      formValidate: {
        attention: 'N', // (N：普通 Y：重要)
        isPublic: '1',
        note: ''
      },
      deleteId: '',
      deleteMomeCtrl: false,
      isSubmit: false,
      ruleValidate: {
        attention: [{ required: true, message: '请选择', trigger: 'change' }],
        isPublic: [{ required: true, message: '请选择是否公开', trigger: 'change' }],
        note: [
          { required: true, message: '请填写备注', trigger: 'blur' },
          { max: 512, message: '不能超过512个字符', trigger: 'blur' }
        ]
      },
      noteList: [],
      caseNotesCtrl: false, // 备注
      table: { // 表格数据接口的相关参数
        pageSize: this.config.modalPageSize,
        pageNum: 1,
        totalRecords: 1
      }
    }
  },
  mounted() {
    this.$refs['formValidate'].resetFields()
    this.caseNotesCtrl = true
    this.getCaseNotes()
  },
  methods: {
    // 案件备注
    caseNoteSubmit(name) {
      const url = '/business/clue-memo'
      const ajaxData = {
        clueIdList: [this.id],
        attention: this.formValidate.attention,
        memo: this.formValidate.note,
        isPublic: this.formValidate.isPublic === '1'
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          this.$post(url, ajaxData).then(res => {
            this.isSubmit = false
            this.caseNotesCtrl = false
            if (res.code === 0) {
              // 清除备注
              this.$Message.success('操作成功！')
              this.$emit('reloadList', true)
              this.cancel()
            } else {
              this.$Message.error(res.message)
              this.cancel()
            }
          })
        }
      })
    },
    // 获取备注录
    getCaseNotes() {
      const url = '/business/clue-memoes'
      const ajaxData = {
        current: this.table.pageNum,
        size: this.table.pageSize,
        clueId: this.id
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0) {
          this.noteList = this.noteList.concat(res.data.records)
          this.noteList.forEach(item => {
            if (item.createTime) {
              item.createTime = item.createTime.replace('T', ' ')
            }
          })
        }
      })
    },
    // 删除备注
    deleteMemo(id) {
      this.deleteId = id
      this.deleteMomeCtrl = true
    },
    // 确认删除备注
    isDeleteFn() {
      const url = `/business/clue-memo/${this.deleteId}`
      this.isSubmit = true
      this.$del(url).then(res => {
        this.isSubmit = false
        if (res.code == 0) {
          this.$Message.success('删除成功！')
          this.deleteMomeCtrl = false
          this.$emit('reloadList', true)
          this.cancel()
        } else {
          this.$message.error(res.message || '删除失败！')
        }
      })
    },
    // 滚动加载更多备注记录
    handleReachBottom () {
      return new Promise(resolve => {
        this.table.pageNum = this.table.pageNum + 1
        this.getCaseNotes()
        resolve()
      })
    },
    // 关闭清除备注
    cancel() {
      this.noteList = []
      this.table.pageNum = 1
      this.table.pageSize = 5
      this.caseNotesCtrl = false
      this.$emit('reloadList', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.import-attention{
    color: #ff5555
}
.fs-16{
    font-size: 16px;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/view/clue/myClue/plugin/listOptions.vue